var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngelist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#78a2d2",
    d: "M23.998 8.128c.063-1.379-1.612-2.376-2.795-1.664c-1.23.598-1.322 2.52-.156 3.234c1.2.862 2.995-.09 2.951-1.57m0 7.748c.063-1.38-1.612-2.377-2.795-1.665c-1.23.598-1.322 2.52-.156 3.234c1.2.863 2.995-.09 2.951-1.57zm-20.5 1.762L0 6.364h3.257l2.066 8.106l2.245-8.106h3.267l2.244 8.106l2.065-8.106h3.257l-3.54 11.274H11.39q-1.096-4.07-2.188-8.14l-2.233 8.14H3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngelist);
export default __webpack_public_path__ + "static/media/angelist.c3a36afeb1f26663cb373d18f3f8f627.svg";
export { ForwardRef as ReactComponent };